<template>
  <Teleport to="body">
    <MobileNav />
    <MobileMenu />
  </Teleport>
  <div class="mobile-layout">
    <MobileMainContainer>
      <slot></slot>
    </MobileMainContainer>
    <MobileFooter />
  </div>
</template>

<script lang="ts">
import MobileMainContainer from "@/components/layout/MobileMainContainer.vue"
import MobileNav from "@/components/layout/MobileNav.vue"
import MobileMenu from "@/components/layout/MobileMenu.vue"

import { defineComponent } from "vue"
import { useLocalStorage } from "@vueuse/core"
import MobileFooter from "@/components/layout/MobileFooter.vue"
import { useViewportHeight } from "@/composables/useViewportHeight"

export default defineComponent({
  components: {
    MobileMainContainer,
    MobileNav,
    MobileMenu,
    MobileFooter,
  },
  setup() {
    const access_token = useLocalStorage("access_token", null)
    const refresh_token = useLocalStorage("refresh_token", null)
    const scope = useLocalStorage("scope", null)
    const { vh } = useViewportHeight()

    return { access_token, refresh_token, scope, vh }
  },
  mounted() {
    if (this.access_token) {
      this.$store.dispatch("auth/setTokenData", {
        access_token: this.access_token,
        refresh_token: this.refresh_token,
        scope: this.scope,
      })
    }
  },
})
</script>
<style scoped>
.mobile-layout {
  background: #212429;
  min-height: 100vh;
}
</style>
